// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeekdaySelector_container__sqCLo {
  display: flex;
  justify-content: center;
  width: 100%;
}

.WeekdaySelector_weekday__4LmgJ {
  margin: auto;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 1px solid #cfcfcf;
}
.WeekdaySelector_weekday__4LmgJ label {
  height: 100%;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}
.WeekdaySelector_weekday__4LmgJ[data-selected=true] {
  background: #BCCF00;
  border: none;
}
.WeekdaySelector_weekday__4LmgJ[data-selected=true] label {
  color: white;
}
.WeekdaySelector_weekday__4LmgJ[data-selected=true][data-disabled=true] {
  background-color: lightgray;
}
.WeekdaySelector_weekday__4LmgJ[data-red=true] {
  border-color: red;
}
.WeekdaySelector_weekday__4LmgJ[data-disabled=true] {
  border-color: lightgray;
  color: lightgray;
}
.WeekdaySelector_weekday__4LmgJ:last-child {
  margin-right: 0;
}
.WeekdaySelector_weekday__4LmgJ:first-child {
  margin-left: 0;
}
@media (max-width: 400px) {
  .WeekdaySelector_weekday__4LmgJ {
    width: 2rem;
    height: 2rem;
  }
  .WeekdaySelector_weekday__4LmgJ label {
    font-size: 1rem;
  }
}
.WeekdaySelector_weekday__4LmgJ[data-small=true] {
  width: 1.5rem;
  height: 1.5rem;
}
.WeekdaySelector_weekday__4LmgJ[data-small=true] label {
  font-size: 0.8rem;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/WeekdaySelector/WeekdaySelector.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,uBAAA;EACA,WAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EAEA,kBAAA;EACA,yBAAA;AADF;AAGE;EACE,YAAA;EACA,eAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,yBAAA;UAAA,iBAAA;AAHJ;AAME;EACE,mBAAA;EACA,YAAA;AAJJ;AAMI;EACE,YAAA;AAJN;AAOI;EACE,2BAAA;AALN;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,uBAAA;EACA,gBAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAYE;EACE,cAAA;AAVJ;AAaE;EAjDF;IAkDI,WAAA;IACA,YAAA;EAVF;EAYE;IACE,eAAA;EAVJ;AACF;AAaE;EACE,aAAA;EACA,cAAA;AAXJ;AAaI;EACE,iBAAA;EACA,iBAAA;AAXN","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.weekday {\n  margin: auto;\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 50%;\n  border: 1px solid #cfcfcf;\n}\n.weekday label {\n  height: 100%;\n  font-size: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n}\n.weekday[data-selected=true] {\n  background: #BCCF00;\n  border: none;\n}\n.weekday[data-selected=true] label {\n  color: white;\n}\n.weekday[data-selected=true][data-disabled=true] {\n  background-color: lightgray;\n}\n.weekday[data-red=true] {\n  border-color: red;\n}\n.weekday[data-disabled=true] {\n  border-color: lightgray;\n  color: lightgray;\n}\n.weekday:last-child {\n  margin-right: 0;\n}\n.weekday:first-child {\n  margin-left: 0;\n}\n@media (max-width: 400px) {\n  .weekday {\n    width: 2rem;\n    height: 2rem;\n  }\n  .weekday label {\n    font-size: 1rem;\n  }\n}\n.weekday[data-small=true] {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.weekday[data-small=true] label {\n  font-size: 0.8rem;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WeekdaySelector_container__sqCLo`,
	"weekday": `WeekdaySelector_weekday__4LmgJ`
};
export default ___CSS_LOADER_EXPORT___;
